module.exports = __webpack_public_path__ + "img/map-pin.508c848e.svg";